import React, { useEffect, useState } from "react";
import { getVideoHistoryFileUrl } from "../live-campaign-repository";

export const ScreenshotsSection = ({ screenshots }) => {
  const [imageUrls, setImageUrls] = useState([]);

  useEffect(() => {
    const fetchImageUrls = async () => {
      if (screenshots && screenshots.length > 0) {
        const urls = await Promise.all(
          screenshots.map(async (screenshot) => {
            const url = await getVideoHistoryFileUrl(screenshot);
            return url;
          })
        );
        setImageUrls(urls);
      }
    };

    fetchImageUrls();
  }, [screenshots]);

  if (!screenshots || screenshots.length === 0) {
    return null;
  }

  return (
    <div>
      <h4 className="font-medium text-gray-900 mb-2">Screenshots</h4>
      <div className="flex gap-2 flex-wrap">
        {imageUrls.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`Screenshot ${index + 1}`}
            className="w-20 h-20 object-cover rounded-lg border"
          />
        ))}
      </div>
    </div>
  );
};
